import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import PasswordStep from './PasswordStep';
import MobileVerificationStep from './MobileVerificationStep';
import AddressStep from './AddressStep';
import Footer from 'components/Footer/Footer';
import { AssetUrls } from 'config/assets';
import { tradeApi } from 'store/services/trade/tradeApi';
import '../Login.css';

const OnboardingFlow = () => {
  const [step, setStep] = useState(1);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const email = searchParams.get('email') || '';

  const handleNext = () => {
    setStep((s) => s + 1);
  };

  const handleComplete = async () => {
    // Invalidate trade packages cache to ensure fresh fetch with proper auth
    dispatch(tradeApi.util.invalidateTags(['TradePackages']));
    
    // Longer delay to ensure all cookies and auth state are properly set
    // Increased from 200ms to 500ms for cross-domain cookie reliability
    await new Promise(resolve => setTimeout(resolve, 500));
    
    navigate('/home');
  };

  useEffect(() => {
    document.body.classList.add('landing-page');
    return () => {
      document.body.classList.remove('landing-page');
    };
  }, []);

  return (
    <div className="login-page-wrapper onboarding-page-wrapper">
      <div className="login-page-content">
        <img
          className="logo-main"
          src={AssetUrls.logos.black}
          alt="magictrade-logo-black"
        />

        {step === 1 && <PasswordStep email={email} onNext={handleNext} />}
        {step === 2 && <MobileVerificationStep onNext={handleNext} />}
        {step === 3 && <AddressStep onNext={handleComplete} />}
      </div>

      <Footer />
    </div>
  );
};

export default OnboardingFlow;
